import api from '@services/api';

function handleNullFields(response) {
  if (response == null) {
    return '';
  }

  return response;
}

function handleCEP(customerObj, fromCustomerNew = false) {
  const zipcode = fromCustomerNew ? customerObj.address_attributes.zipcode.replace(/\D/g, '') : customerObj.cep.replace(/\D/g, '');
  const requestOptions = { zipcode };
  const customer = fromCustomerNew ? customerObj.address_attributes : customerObj;

  if (zipcode.length === 8) {
    api.get('/admin/addresses/search', requestOptions)
      .then((response) => {
        const address = response.data;

        customer.state = handleNullFields(address.state);
        customer.city = handleNullFields(address.city);
        customer.neighborhood = handleNullFields(address.neighborhood);
        if (fromCustomerNew) {
          customer.street = handleNullFields(address.street);
        } else {
          customer.address = handleNullFields(address.street);
        }
      })
      .catch(() => {
        console.error('CEP inválido');
      });
  }

  return null;
}

export default handleCEP;
